var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PageWrapper',{attrs:{"bodyClass":"page-wrapper__content"}},[[_c('EvidenceForm',{attrs:{"submitButtonText":_vm.$lang.submit},on:{"submit":_vm.addNewEvidence}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }